import { buildUrl } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import contractFields from '../../fields/contractFields';
import { TERMINAL_CONTRACTS } from '../apiUrls';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 *
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => {
        return {
            [contractFields.UUID.key]: item[contractFields.UUID.key],
            [contractFields.APPLICATION.key]: item[contractFields.APPLICATION.key],
            [contractFields.LAST_REMOTE_COLLECTION_DATE.key]: item[contractFields.LAST_REMOTE_COLLECTION_DATE.key],
            [contractFields.NUMBER.key]: item[contractFields.NUMBER.key],
            [contractFields.BANK_CODE.key]: item[contractFields.BANK_CODE.key],
            [contractFields.RANK.key]: item[contractFields.RANK.key],
            [contractFields.LEGAL_AND_BUSINESS_NAME.key]: item[contractFields.LEGAL_AND_BUSINESS_NAME.key],
            [contractFields.REGISTRATION_NUMBER.key]: item[contractFields.REGISTRATION_NUMBER.key],
            [contractFields.LABEL.key]: item[contractFields.LABEL.key],
            [contractFields.X25_ADDRESS.key]: item[contractFields.X25_ADDRESS.key],
            [contractFields.ITP.key]: item[contractFields.ITP.key],
            [contractFields.CB_VERSION.key]: item[contractFields.CB_VERSION.key],
            [contractFields.CREATED_AT.key]: item[contractFields.CREATED_AT.key],
            [contractFields.UPDATED_AT.key]: item[contractFields.UPDATED_AT.key],
            [contractFields.LAST_CONNECTION_DATE.key]: item[contractFields.LAST_CONNECTION_DATE.key],
            [contractFields.LAST_SSL_VERSION.key]: item[contractFields.LAST_SSL_VERSION.key],
            [contractFields.LAST_CONNECTION_TYPE.key]: item[contractFields.LAST_CONNECTION_TYPE.key],
            [contractFields.LAST_REMOTE_COLLECTION_DATE.key]: item[contractFields.LAST_REMOTE_COLLECTION_DATE.key],
            [contractFields.LAST_SOURCE_IP.key]: item[contractFields.LAST_SOURCE_IP.key],
            [contractFields.LAST_ICCID.key]: item[contractFields.LAST_ICCID.key],
            [contractFields.LAST_ICCID_OPERATOR.key]: item[contractFields.LAST_ICCID_OPERATOR.key],
            [contractFields.ACTIVE_ICCID.key]: item[contractFields.ACTIVE_ICCID.key],
            [contractFields.SIM_STATUS.key]: item[contractFields.SIM_STATUS.key],
            [contractFields.LAST_SSL_VERSION.key]: item[contractFields.LAST_SSL_VERSION.key],
            [contractFields.LAST_CONNECTION_TYPE.key]: item[contractFields.LAST_CONNECTION_TYPE.key],
            [contractFields.POS_TERMINAL.key]: item[contractFields.POS_TERMINAL.key],
            [contractFields.REMPART.MODEL.key]: item[contractFields.REMPART.MODEL.key],
            [contractFields.REMPART.SPECIFICATION.key]: item[contractFields.REMPART.SPECIFICATION.key],
            [contractFields.REMPART.BULLETINS.key]: item[contractFields.REMPART.BULLETINS.key],
            [contractFields.REMPART.ERT.key]: item[contractFields.REMPART.ERT.key],
            [contractFields.REMPART.ERT_CODE.key]: item[contractFields.REMPART.ERT_CODE.key],
            [contractFields.REMPART.CB_APPROVAL.key]: item[contractFields.REMPART.CB_APPROVAL.key],
            [contractFields.REMPART.CB_APPROVAL_DATE.key]: item[contractFields.REMPART.CB_APPROVAL_DATE.key],
            [contractFields.REMPART.PCI_VERSION.key]: item[contractFields.REMPART.PCI_VERSION.key],
            [contractFields.REMPART.PCI_EXPIRATION_DATE.key]: item[contractFields.REMPART.PCI_EXPIRATION_DATE.key],
            [contractFields.REMPART.PCI_PP_VERSION.key]: item[contractFields.REMPART.PCI_PP_VERSION.key],
            [contractFields.REMPART.PCI_PP_EXPIRATION_DATE.key]: item[contractFields.REMPART.PCI_PP_EXPIRATION_DATE.key],
            [contractFields.REMPART.EXPIRATION_DATE.key]: item[contractFields.REMPART.EXPIRATION_DATE.key],
            [contractFields.REMPART.END_OF_USE_DATE.key]: item[contractFields.REMPART.END_OF_USE_DATE.key],
            [contractFields.REMPART.END_OF_DEPLOYMENT_DATE.key]: item[contractFields.REMPART.END_OF_DEPLOYMENT_DATE.key]
        };
    });
    data.items = mappedItems;
    data.totalResults = totalResults;

    return data;
}

const queryGetTerminalContracts = ({ query, posTerminalId }, enabled) => {
    return {
        queryKey: [TERMINAL_CONTRACTS.COLLECTION.queryKey, query, posTerminalId],
        queryFn: async () => {
            const response = await client.get(buildUrl(TERMINAL_CONTRACTS.COLLECTION.url, { posTerminal: posTerminalId, ...query }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetTerminalContracts;